<tree-root #tree [nodes]="treeModels" [options]="options"></tree-root>